const url = {
    dev: {
        publicUrl: 'https://www.puditech.com/api',
        manageUrl: 'https://www.puditech.com/api/admin'

        // publicUrl: 'https://test.api.cxc-group.com/api/admin',
        // manageUrl: 'https://test.api.cxc-group.com/api/admin'
    },
    pro: {
        publicUrl: 'https://www.puditech.com/api',
        manageUrl: 'https://www.puditech.com/api/admin'
    }
}

export const get = () => {
    if(process.env.NODE_ENV === 'production'){
        return url['pro']
    }else{
        return url['dev']
    }
}
